/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import { useAppDispatch } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { checkEnableParseJSON } from 'components/helper/helper';
import { debounce } from 'lodash';
import {
  getEducationalProgram,
  updateEducationalProgram,
} from 'app/activitiesAndHonors/activitiesAndHonorsSlice';
import Grid from '@mui/joy/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';
// import Cookies from 'js-cookie';
// import { authenticateSettings } from 'components/helper/appConfig';
// import TextInput from 'components/input/textInput';
// import * as Yup from 'yup';
const StyledCard = styled(Card)(({ theme }) => ({
  // marginBottom: theme.spacing(2),
  borderRadius: '12px',
  boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)',
  border: '1px solid #E0E0E0',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  '& .MuiCardContent-root': {
    paddingTop: '10px',
    paddingBottom: '5px',
  }
}));

// const rules = Yup.object({
//   number_brothers_and_sisters_k12: Yup.number().min(0, 'Invalid').integer('Invalid'),
//   number_brothers_and_sisters_college: Yup.number().min(0, 'Invalid').integer('Invalid'),
//   number_brothers_and_sisters_received_bachelor_degree: Yup.number()
//     .min(0, 'Invalid')
//     .integer('Invalid'),
//   number_year_received_income: Yup.number().min(1, 'Invalid').max(99, 'Invalid').integer('Invalid'),
// });

const EducationalProgramsOnly = ({ check, isMobile, onDataChange, disabled }: { check?: any, isMobile?: boolean, onDataChange?: (data: any) => void, disabled?: boolean }) => {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const formik = useFormik({
    initialValues: {
      avid: '',
      federal_outreach_program: '',                                 // added   - 2025-10-02
      eap_eop_s_camp: '',                                           // added   - 2025-10-02
      puente_project: '',
      umoja_project: '',                                            // added   - 2025-10-02
      MESA_project: '',
      ilp: '',
      foster_youth_support_program: '',                             // added   - 2025-10-02
      // average_hours_worked_per_week: '',
      // is_more_25_percent_work_related_major: '',
      // average_hours_activities_per_week: '',
      // is_leadership_positions: '',
      // wish_to_apply_EOP: '',
      // is_enrolled_EOP: '',
      // where_plan_to_live: '',
      // number_brothers_and_sisters_k12: '',
      // number_brothers_and_sisters_college: '',
      // number_brothers_and_sisters_received_bachelor_degree: '',
      // languages_spoken_in_home: '',
      // is_received_income_from_public_assistance_program: '',
      // number_year_received_income: '',
      // type_of_aid: '',
      // is_participated_in_publicly_funded_programs: '',
      // publicly_funded_programs: '',
      // is_work_primarily_to_contribute: '',
      // work_primarily_to_contribute: '',
      // campus_enrolled_EOP: '',
    },
    //validationSchema: rules,
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        const newValues = {
          csu_info: JSON.stringify(values),
          student_id: studentId,
        };
        await dispatch(updateEducationalProgram(newValues));
      } else {
        handleLogout();
      }
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      let res = await dispatch(getEducationalProgram(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        const values: any = checkEnableParseJSON(dataLoaded.csu_info);
        formik.resetForm({ values: { ...formik.values, ...values } });
      }
      setLoading(false);
      formik.setStatus('idle');
    } else {
      // force logout
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);

  // Call onDataChange when formik values change
  React.useEffect(() => {
    if (onDataChange) {
      onDataChange(formik.values);
    }
  }, [formik.values, onDataChange]);
  // Auto save function ==========
  React.useEffect(() => {
    formik.dirty && debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1000),
    []
  );
  // Auto save function ==========

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-form-fields">
      <div className="text-field-mid fs-3 mb-4">Educational Programs Participation</div>
      <div className="text-dart span-csu-logo mb-4">
        Have you participated in any of these programs in high school and beyond?
      </div>
      
      <Grid container spacing={2}>
        <Grid xs={12}>
          <StyledCard>
            <CardContent >
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="AVID *"
                    values={formik.values.avid}
                    name="avid"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.avid === 'true' || formik.values.avid === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="Federal Outreach Program (TRIO, Talent Search/EOC Upward Bound, GEAR UP) *"
                    values={formik.values.federal_outreach_program}
                    name="federal_outreach_program"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.federal_outreach_program === 'true' || formik.values.federal_outreach_program === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="EAP/EOP&S/CAMP *"
                    values={formik.values.eap_eop_s_camp}
                    name="eap_eop_s_camp"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.eap_eop_s_camp === 'true' || formik.values.eap_eop_s_camp === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="Puente Project *"
                    values={formik.values.puente_project}
                    name="puente_project"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.puente_project === 'true' || formik.values.puente_project === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="Umoja Project *"
                    values={formik.values.umoja_project}
                    name="umoja_project"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.umoja_project === 'true' || formik.values.umoja_project === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="MESA Project *"
                    values={formik.values.MESA_project}
                    name="MESA_project"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.MESA_project === 'true' || formik.values.MESA_project === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="Independent Living Project (ILP) *"
                    values={formik.values.ilp}
                    name="ilp"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.ilp === 'true' || formik.values.ilp === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="pb-3"
                    label="Foster Youth Support Program *"
                    values={formik.values.foster_youth_support_program}
                    name="foster_youth_support_program"
                    onChange={formik.handleChange}
                    isMissing={!(formik.values.foster_youth_support_program === 'true' || formik.values.foster_youth_support_program === 'false') && check}
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>
    </div>
  );
};

export default EducationalProgramsOnly;
